import React from 'react';
import './Business.css';

class Business extends React.Component {
    render() {
        return (
            <section className='main-business'>
                <figure className="main-business__image">
                    <img src={this.props.business.imageSrc} alt='Pizza Margarita'/>
                </figure>
                <h2>{this.props.business.name}</h2>
                <article className='main-business__info'>
                    <article className='main-business__info--address'>
                        <p>{this.props.business.address}</p>
                        <p>{this.props.business.city}</p>
                        <p>{this.props.business.zipCode}</p>
                    </article>
                    <article className="main-business__info--reviews">
                        <h3>{this.props.business.category}</h3>
                        <h4 className='rating'>{this.props.business.rating}</h4>
                        <p>{this.props.business.reviewCount}</p>
                    </article>
                </article>
            </section>
        )
    }
}

export default Business;